import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 0EB6BB85-4BE2-4608-BABF-2EF135D420A7
 * name bookmark-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-outline.svg
 * tags
 */
export const BookmarkOutlineIcon = createSvgIcon(<><path d="M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z" /></>, 'BookmarkOutlineIcon');
export default BookmarkOutlineIcon